<app-modal-window title="User Steam"
                  (close)="close()">

  <div class="user-steam-container">
    <ng-container *ngIf="(userSteam |async) as userSteam; else loading">
      <pre>{{userSteam | json}}</pre>
    </ng-container>
  </div>

</app-modal-window>

<ng-template #loading>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>


